import React, { useEffect } from 'react';
import * as S from './Styles';
import useEscapeKey from '../../../hooks/useEscapeKey';

interface ExpandedModalProps {
  modalVisible: boolean;
  toggleShowModal: () => void;
  children: React.ReactNode;
}

const ExpandedModal: React.FC<ExpandedModalProps> = ({ modalVisible, toggleShowModal, children }) => {
  const modalRef = useEscapeKey(toggleShowModal) as React.RefObject<HTMLDivElement>;

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      event.preventDefault();
      event.stopPropagation();
    };

    if (modalVisible) {
      // Disable scrolling on the hidden body
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';

      document.addEventListener('keydown', handleKeyDown);
    } else {
      // Restore scrolling on the body
      document.body.style.overflow = '';
      document.body.style.position = '';

      document.removeEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [modalVisible]);

  if (!modalVisible) {
    return null;
  }

  return (
    <>
      <S.ExpandedModalContainer ref={modalRef}>
        <S.ExitModalButton onClick={toggleShowModal}>
          <img
            src="https://www.fmicassets.com/sites/fender.com/themes/img/placeholders/close-icon-mobile-212529.jpg"
            alt="Close Full Screen Gallery Modal"
          />
        </S.ExitModalButton>
        <S.ModalBackDrop />
        <S.StyledChildrenContainer>{children}</S.StyledChildrenContainer>
      </S.ExpandedModalContainer>
    </>
  );
};

export default ExpandedModal;
